import { TOPIC_ADD } from "../constants/topicConstants";

export const addTopic = (item) => async (dispatch, getState) => {
  dispatch({ type: TOPIC_ADD, payload: item });
  localStorage.setItem(
    "gsprklTopicVideos",
    JSON.stringify(getState().topic.topicVideos)
  );
};
